module.exports = {
  path: '/basketballer',
  name: 'basketballer',
  meta: { title: '球员管理', icon: 'el-icon-upload' },
  component: () => import('../views/basketballer/basketballer.vue') //子分类挂载过度,
}
